import { jsPDF } from "jspdf";
import { tmpQrCodeOprationImg } from "./tmpQrCodeOprationImg-base64.js";
import { MPlus_Encoded_Base64 } from "./mplus-encoded-base64.js";
import QRCode from "qrcode";
import moment from "moment";

export async function createFacilityQrCodePdf(userInfoList, groupId) {
  // ----- PDF作成処理 ----- //
  // Default export is a4 paper, portrait, using millimeters for units
  const doc = new jsPDF("a4");

  // pdfのタイトル（タブに表示されるやつ）
  doc.setProperties({
    title: "要配慮者施設QRコード発行者一覧"
  });

  // フォントデータの適応
  doc.addFileToVFS("mplus.ttf", MPlus_Encoded_Base64);
  doc.addFont("mplus.ttf", "mplus", "normal");
  doc.setFont("mplus", "normal");

  // フォントサイズの設定
  doc.setFontSize(12);

  // 固定値の定義（Wordを元に数値を入力）
  const WIDTH = 210;
  const HEIGHT = 297;
  const SIDE_MARGIN = 30;
  const TOP_MARGIN = 35;
  const BOTTOM_MARGIN = 30;
  const ONE_PAGE_LINES = 35;
  const ONE_LINE_HEIGHT =
    (HEIGHT - TOP_MARGIN - BOTTOM_MARGIN) / ONE_PAGE_LINES;
  const ONE_LINE_CHARACTERS = 35;
  // 全角文字 1文字当たりの幅
  const ONE_CHARACTER_WIDTH = (WIDTH - SIDE_MARGIN * 2) / ONE_LINE_CHARACTERS;
  // 連続した行の行間
  const LINE_HEIGHT_FACTOR = 1.5;
  // QRコード画像のサイズ
  const QR_IMAGE_SIZE = 55;
  // QRコード画像の枠の右に確保するスペース
  const QR_IMAGE_RIGHT_MARGIN = 10;

  // ページ番号
  var creatingPageNo = 1;

  /* 以下、1ページ分 */
  for (let userInfo of userInfoList) {
    // 1ページ目でなければ新しいページを作成
    if (creatingPageNo != 1) {
      doc.addPage("a4");
    }

    // 変数用意
    var currentLine = 0;

    currentLine += 2;

    /* 右上 */
    doc.setFontSize(26);
    doc.rect(
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 27,
      ONE_LINE_HEIGHT * 0.6,
      ONE_CHARACTER_WIDTH * 10,
      ONE_LINE_HEIGHT * currentLine
    );

    doc.text(
      "施設等用",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 27.5 + 1,
      ONE_LINE_HEIGHT * currentLine + 1
    );
    doc.setFontSize(12);

    /* タイトル */
    doc.text(
      "鹿児島県原子力災害時住民避難支援・円滑化システム　仮ＱＲコード",
      SIDE_MARGIN,
      TOP_MARGIN
    );

    // 発行単位名
    var manageGrpNameItem = doc.splitTextToSize(
      `発行単位：${groupId}`,
      WIDTH - SIDE_MARGIN * 2
    );

    manageGrpNameItem = proofreading(manageGrpNameItem);

    doc.text(
      manageGrpNameItem,
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );

    currentLine += 1;

    /* QR */
    // 有効期限(YYYYMMDD)の作成
    // userInfo.issue_date : YYYYMMDD であること
    const formattedDate = moment(userInfo.issue_date)
      .add(parseInt(userInfo.expiration_date) - 1, "d")
      .format("YYYYMMDD");
    var qrStr = JSON.stringify({
      S: "Con",
      G: groupId,
      Q: [userInfo.cns_person_id],
      Y: formattedDate
    });
    var qrURL = await QRCode.toDataURL(qrStr);

    doc.addImage(
      qrURL,
      "JPEG",
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      QR_IMAGE_SIZE,
      QR_IMAGE_SIZE
    );
    doc.rect(
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      QR_IMAGE_SIZE,
      QR_IMAGE_SIZE
    );

    /* ユーザー情報 */

    // No //
    currentLine += 1;
    doc.text(
      "施設等名：",
      SIDE_MARGIN + QR_IMAGE_RIGHT_MARGIN + QR_IMAGE_SIZE,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );
    doc.text(
      `${userInfo.fa_name}`,
      SIDE_MARGIN +
        QR_IMAGE_RIGHT_MARGIN +
        QR_IMAGE_SIZE +
        ONE_CHARACTER_WIDTH * 4 +
        4,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );
    doc.line(
      SIDE_MARGIN + QR_IMAGE_RIGHT_MARGIN + QR_IMAGE_SIZE,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine + 1,
      WIDTH - 10 - SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine + 1
    );

    // 氏名 //
    currentLine += 2;
    var name = doc.splitTextToSize(
      userInfo.name_kanji,
      WIDTH -
        SIDE_MARGIN * 2 -
        QR_IMAGE_RIGHT_MARGIN -
        QR_IMAGE_SIZE -
        ONE_CHARACTER_WIDTH * 3
    );

    doc.text(
      "氏名：",
      SIDE_MARGIN + QR_IMAGE_RIGHT_MARGIN + QR_IMAGE_SIZE,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );
    doc.text(
      name,
      SIDE_MARGIN +
        QR_IMAGE_RIGHT_MARGIN +
        QR_IMAGE_SIZE +
        ONE_CHARACTER_WIDTH * 2 +
        4,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      { lineHeightFactor: LINE_HEIGHT_FACTOR }
    );
    doc.line(
      SIDE_MARGIN + QR_IMAGE_RIGHT_MARGIN + QR_IMAGE_SIZE,
      TOP_MARGIN + ONE_LINE_HEIGHT * (currentLine + name.length - 1) + 1,
      WIDTH - 10 - SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * (currentLine + name.length - 1) + 1
    );

    /* 利用上の注意事項 */
    currentLine = 13;
    doc.text(
      "○　利用上の注意事項",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );

    // 1 //
    currentLine += 1;

    var attentionItem1 = doc.splitTextToSize(
      "　鹿児島県原子力災害時住民避難支援・円滑化システムはＱＲコードを利用して避難所などでの登録を行うシステムです。",
      WIDTH - SIDE_MARGIN * 2 - ONE_CHARACTER_WIDTH * 2
    );

    attentionItem1 = proofreading(attentionItem1);

    doc.text(
      "１",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );
    doc.text(
      attentionItem1,
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      { lineHeightFactor: LINE_HEIGHT_FACTOR }
    );

    // 2 //
    currentLine += attentionItem1.length;

    var attentionItem2 = doc.splitTextToSize(
      "　この仮ＱＲコードを使用すれば，スマートフォンをお持ちでない方も鹿児島県原子力災害時住民避難支援・円滑化システムでの登録を行うことができます。",
      WIDTH - SIDE_MARGIN * 2 - ONE_CHARACTER_WIDTH * 2
    );

    attentionItem2 = proofreading(attentionItem2);

    doc.text(
      "２",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );
    doc.text(
      attentionItem2,
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      { lineHeightFactor: LINE_HEIGHT_FACTOR }
    );

    // 3 //
    currentLine += attentionItem2.length;

    var attentionItem3 = doc.splitTextToSize(
      // eslint-disable-next-line
      `　原子力災害時に，${nameAdjuster(userInfo.name_kanji)}さんが施設の方と一緒に避難する際に，${nameAdjuster(userInfo.name_kanji)}さんの状況をあなたのスマートフォンの鹿児島県原子力災害時住民避難支援・円滑化システムで確認できるようにするために，この仮ＱＲコードをお渡しするものです。`,
      WIDTH - SIDE_MARGIN * 2 - ONE_CHARACTER_WIDTH * 2
    );

    attentionItem3 = proofreading(attentionItem3);

    doc.text(
      "３",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );
    doc.text(
      attentionItem3,
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      { lineHeightFactor: LINE_HEIGHT_FACTOR }
    );

    // 4 //
    currentLine += attentionItem3.length;

    var attentionItem4 = doc.splitTextToSize(
      // eslint-disable-next-line
      `　この仮ＱＲコードのデータと，あなたのスマートフォンの鹿児島県原子力災害時住民避難支援・円滑化システムに登録された${nameAdjuster(userInfo.name_kanji)}さんのデータを関連づける必要があります。`,
      WIDTH - SIDE_MARGIN * 2 - ONE_CHARACTER_WIDTH * 2
    );

    attentionItem4 = proofreading(attentionItem4);

    doc.text(
      "４",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );
    doc.text(
      attentionItem4,
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      { lineHeightFactor: LINE_HEIGHT_FACTOR }
    );

    currentLine += attentionItem4.length;

    var attentionItem5 = doc.splitTextToSize(
      "  関連付けの手順は以下のとおりです。",
      WIDTH - SIDE_MARGIN * 2 - ONE_CHARACTER_WIDTH * 2
    );

    attentionItem5 = proofreading(attentionItem5);

    doc.text(
      attentionItem5,
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    currentLine += attentionItem5.length + 1;

    /* スマートフォンに登録したデータとの関連づけ */
    doc.text(
      "○　スマートフォンに登録したデータとの関連付け",
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );

    currentLine += 1;

    doc.text(
      "　　裏面をご確認ください。",
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );

    /* お問い合わせ */
    currentLine += 3.5;
    doc.rect(
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 17,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20,
      ONE_CHARACTER_WIDTH * 17,
      ONE_LINE_HEIGHT * 4.5
    );
    doc.setFontSize(10.5);
    currentLine += 1;
    doc.text(
      "お問合せ先",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 18,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20
    );
    currentLine += 1;
    doc.text(
      "鹿児島県　危機管理防災局",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 18,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20
    );
    currentLine += 1;
    doc.text(
      "　原子力安全対策課　原子力防災対策係",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 18,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20
    );
    currentLine += 1;
    doc.text(
      "　TEL:099-286-2543",
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 18,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20
    );
    doc.setFontSize(12);

    /* 注意点 */
    currentLine += 1;
    doc.rect(
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20,
      WIDTH - SIDE_MARGIN * 2 - 5,
      ONE_LINE_HEIGHT * 3.5
    );
    doc.setFontSize(10.5);
    currentLine += 1;
    doc.text(
      "この仮ＱＲコードは，あなたのスマートフォンとの重複処理が完了したら不要に",
      SIDE_MARGIN + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20
    );
    currentLine += 1;
    doc.text(
      "なりますので，細かく裁断して破棄してもかまいません。",
      SIDE_MARGIN + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20
    );
    currentLine += 1;
    doc.text(
      "※施設等では本書を保管し，原子力災害の避難時に所持してください。",
      SIDE_MARGIN + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine - 20
    );
    doc.setFontSize(12);

    /////////////////////////////////////////////////////////////////////////////////////////////
    /* 改ページ */
    /////////////////////////////////////////////////////////////////////////////////////////////
    doc.addPage("a4");
    currentLine = 0;
    creatingPageNo++;

    /* 左右のボックスのライン */
    let leftCurrentLine = 0;
    let rightCurrentLine = 0;

    /* 左右の間隔 */
    const WIDTH_LEFT_TO_RIGHT = 18;

    doc.text(
      "○ スマートフォンに登録したデータとの関連付け",
      SIDE_MARGIN - 0.5,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );

    currentLine += 1;

    var relationItem3 = doc.splitTextToSize(
      "「仮ＱＲコードの取り込み」および「関連付け（重複処理）」を以下の手順にて行ってください。",
      WIDTH - SIDE_MARGIN * 2 - ONE_CHARACTER_WIDTH * 2
    );

    relationItem3 = proofreading(relationItem3);

    doc.text(
      relationItem3,
      SIDE_MARGIN + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    /* 仮ＱＲコードの取り込み 左ボックス*/
    leftCurrentLine = currentLine;
    leftCurrentLine += 1.5;

    doc.rect(
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine,
      ONE_CHARACTER_WIDTH * 16.5,
      BOTTOM_MARGIN * 5.2
    );

    doc.setFontSize(8.5);

    // 重複2回させることで、疑似的にboldに見せている
    for (let i = 0; i < 2; i++) {
      doc.text(
        "● 仮ＱＲコードの取り込み ",
        SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
        TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
      );
    }

    leftCurrentLine += 0.7;

    // 1) 左ボックス
    var leftSideItem1 = doc.splitTextToSize(
      "アプリケーションを起動します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    leftSideItem1 = proofreading(leftSideItem1);

    doc.text(
      "1)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem1,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    leftCurrentLine += leftSideItem1.length - 0.2;

    // 2) 左ボックス
    var leftSideItem2 = doc.splitTextToSize(
      "「ホーム」画面で「情報入力・閲覧」ボタンを押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    leftSideItem2 = proofreading(leftSideItem2);

    doc.text(
      "2)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem2,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    leftCurrentLine += leftSideItem2.length - 0.5;

    // 3) 左ボックス
    var leftSideItem3 = doc.splitTextToSize(
      "表示された「情報入力・閲覧メニュー」画面で「登録者情報入力」ボタンを押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    leftSideItem3 = proofreading(leftSideItem3);

    doc.text(
      "3)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem3,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    leftCurrentLine += leftSideItem3.length - 0.5;

    // 4) 左ボックス
    var leftSideItem4 = doc.splitTextToSize(
      "表示された「登録者情報一覧」画面の下部左「追加」ボタンを押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    leftSideItem4 = proofreading(leftSideItem4);

    doc.text(
      "4)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem4,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    leftCurrentLine += leftSideItem4.length - 0.5;

    var leftSideItem5 = doc.splitTextToSize(
      "確認のメッセージ「ＱＲコードを読込む場合は、「ＱＲコード読込」ボタンを押してください。」と表示されますので、「ＱＲコード読込」ボタンを押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    // 5) 左ボックス
    leftSideItem5 = proofreading(leftSideItem5);

    doc.text(
      "5)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem5,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    leftCurrentLine += leftSideItem5.length - 1;

    // 6) 左ボックス
    var leftSideItem6 = doc.splitTextToSize(
      "「ＱＲコード読込」画面が表示されますので、配布したＱＲコードが画面に表示された枠内に収まる様に操作して頂き、５秒ほど静止すると読込まれます。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    leftSideItem6 = proofreading(leftSideItem6);

    doc.text(
      "6)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem6,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    leftCurrentLine += leftSideItem6.length - 1;

    // 7) 左ボックス
    var leftSideItem7 = doc.splitTextToSize(
      "読込が終わりますと、「読込んだＱＲコードの氏名を入力してください。」と表示されますので、読込んだＱＲコードの所有者のお名前を入力してから「ＯＫ」ボタンを押してください。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    leftSideItem7 = proofreading(leftSideItem7);

    doc.text(
      "7)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem7,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    leftCurrentLine += leftSideItem7.length - 1.5;

    // 8) 左ボックス
    var leftSideItem8 = doc.splitTextToSize(
      "「登録者情報一覧」画面の「ＱＲコードを読込した人」の欄に手順７で入力したお名前が表示されます。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    leftSideItem8 = proofreading(leftSideItem8);

    doc.text(
      "8)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem8,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    leftCurrentLine += leftSideItem8.length - 0.3;

    // 左ボックス_完了メッセージ
    doc.text(
      "これで、ＱＲコードの取り込みが完了しました。",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    leftCurrentLine += 1.5;

    // 9) 左ボックス
    var leftSideItem9 = doc.splitTextToSize(
      "「登録者情報一覧」画面の上部左にあるアイコンを押すと、「ホーム」画面に戻ります。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    leftSideItem9 = proofreading(leftSideItem9);

    doc.text(
      "9)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6
    );

    doc.text(
      leftSideItem9,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * leftCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    leftCurrentLine += 0.7;

    /* 関連付け（重複処理）右ボックス */
    rightCurrentLine = currentLine;
    rightCurrentLine += 1.5;

    doc.rect(
      SIDE_MARGIN + ONE_CHARACTER_WIDTH * 17,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine,
      ONE_CHARACTER_WIDTH * 16.5,
      BOTTOM_MARGIN * 5.2
    );

    doc.setFontSize(8.5);

    // 重複2回させることで、疑似的にboldに見せている
    for (let i = 0; i < 2; i++) {
      doc.text(
        "● 関連付け（重複処理）",
        SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
        TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
      );
    }

    rightCurrentLine += 0.7;

    // 1０) 右ボックス
    var rightSideItem1 = doc.splitTextToSize(
      "「ホーム」画面から「ＱＲコード」ボタンを押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem1 = proofreading(rightSideItem1);

    doc.text(
      "10)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem1,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    rightCurrentLine += rightSideItem1.length - 0.5;

    // １１) 右ボックス
    var rightSideItem2 = doc.splitTextToSize(
      "「ＱＲコードメニュー」画面の「重複処理」ボタンを押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem2 = proofreading(rightSideItem2);

    doc.text(
      "11)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem2,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    rightCurrentLine += rightSideItem2.length - 0.5;

    // １２) 右ボックス
    var rightSideItem3 = doc.splitTextToSize(
      "「重複処理メニュー」画面の「登録した登録者情報を重複処理する。」を押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem3 = proofreading(rightSideItem3);

    doc.text(
      "12)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem3,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    rightCurrentLine += rightSideItem3.length - 0.5;

    // １３) 右ボックス
    var rightSideItem4 = doc.splitTextToSize(
      "「重複の登録を行います。」と確認の画面が表示されますので、「ＯＫ」を押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem4 = proofreading(rightSideItem4);

    doc.text(
      "13)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem4,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );
    rightCurrentLine += rightSideItem4.length - 0.5;

    // １４) 右ボックス
    var rightSideItem5 = doc.splitTextToSize(
      "「重複処理（登録）」画面の「ＱＲコードを読込した人」の欄に、ＱＲコードを読み込んだ際に記載したお名前が表示されます。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem5 = proofreading(rightSideItem5);

    doc.text(
      "14)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem5,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    rightCurrentLine += rightSideItem5.length - 0.9;

    // １５) 右ボックス
    var rightSideItem6 = doc.splitTextToSize(
      "該当するお名前の左横に表示される□を押します。（□→☑の表示に替わります。）",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem6 = proofreading(rightSideItem6);

    doc.text(
      "15)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem6,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    rightCurrentLine += rightSideItem6.length - 0.5;

    // １６) 右ボックス
    var rightSideItem7 = doc.splitTextToSize(
      "「重複処理（登録）」画面の「登録者」の欄で、手順１５で☑をつけたご家族にあたる方の左横に表示される○を押します。（○→●の表示に替わります。）",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem7 = proofreading(rightSideItem7);

    doc.text(
      "16)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem7,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    rightCurrentLine += rightSideItem7.length - 1.2;

    // １７) 右ボックス
    var rightSideItem8 = doc.splitTextToSize(
      "手順１６の状態で同じ画面下部左にあります「次へ」ボタンを押します。",
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem8 = proofreading(rightSideItem8);

    doc.text(
      "17)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem8,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    rightCurrentLine += rightSideItem8.length - 0.5;

    // １８) 右ボックス
    var rightSideItem9 = doc.splitTextToSize(
      `「重複処理（確認）」画面が表示され、「${nameAdjuster(
        userInfo.name_kanji
      )}さんの情報に関連付けします」と表示されますので、同じ画面下部左の「登録」ボタンを押してください。（取り消すときは、下部右の「戻る」ボタンを押すと手順１６の状態に戻ります。）関連付けされて、「重複処理（登録）」画面に戻ります。関連付けしたご家族のお名前の右側に「重複済」と表示されます。`,
      ONE_CHARACTER_WIDTH * 15 - ONE_CHARACTER_WIDTH
    );

    rightSideItem9 = proofreading(rightSideItem9);

    doc.text(
      "18)",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.text(
      rightSideItem9,
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT + 5,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    rightCurrentLine += rightSideItem9.length - 2;

    // 右ボックス_完了メッセージ
    doc.text(
      "これで、関連付けは（重複処理）は終わりです。",
      SIDE_MARGIN - 1 + ONE_CHARACTER_WIDTH * WIDTH_LEFT_TO_RIGHT,
      TOP_MARGIN + ONE_LINE_HEIGHT * rightCurrentLine + 6
    );

    doc.setFontSize(12);

    /**
     * Bottom Item List
     */
    currentLine += leftCurrentLine + 3;

    doc.text(
      "＞続けて、他のご家族様の関連付けをされる場合は、",
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );

    currentLine += 1;

    // bottomItem１
    var bottomItem1 = doc.splitTextToSize(
      "「重複処理（登録）」画面の左上の「家マーク」押すと、「ホーム」画面に戻りますので手順２の操作から開始して下さい。",
      WIDTH - SIDE_MARGIN * 2 - ONE_CHARACTER_WIDTH - 2
    );

    bottomItem1 = proofreading(bottomItem1);

    doc.text(
      bottomItem1,
      SIDE_MARGIN + ONE_CHARACTER_WIDTH - 1,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    currentLine += bottomItem1.length;

    doc.text(
      "＞終了する場合は、画面下部から上部に向かって、スワイプ（指を滑らせる）",
      SIDE_MARGIN,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine
    );

    currentLine += 1;

    // bottomItem２
    var bottomItem2 = doc.splitTextToSize(
      "してアプリケーションを終了して下さい。",
      WIDTH - SIDE_MARGIN * 2 - ONE_CHARACTER_WIDTH - 2
    );

    bottomItem2 = proofreading(bottomItem2);

    doc.text(
      bottomItem2,
      SIDE_MARGIN + ONE_CHARACTER_WIDTH - 1,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      {
        lineHeightFactor: LINE_HEIGHT_FACTOR
      }
    );

    currentLine += 0.5;

    // QRコードマニュアルイメージ
    doc.addImage(
      tmpQrCodeOprationImg,
      "JPEG",
      SIDE_MARGIN - 2,
      TOP_MARGIN + ONE_LINE_HEIGHT * currentLine,
      WIDTH - SIDE_MARGIN * 2 - 2,
      45
    );

    doc.setFontSize(12);
    /* 注釈 */

    /* ここまでで1セット */

    creatingPageNo++;
  }

  window.open(doc.output("bloburl"));
}

function proofreading(textArray) {
  var fixCharCount = 0;
  textArray.forEach((ele, i, arr) => {
    // 1行目だけスキップすることに注意
    if (i !== 0) {
      // fixCharCount の数だけ1つ前の要素に文字を渡す
      arr[i - 1] += ele.slice(0, fixCharCount);
      arr[i] = ele.slice(fixCharCount);

      // 配列の頭が句読点だったら句読点を前の要素に渡す
      if (arr[i][0] === "，" || arr[i][0] === "。") {
        arr[i - 1] += arr[i].slice(0, 1);
        arr[i] = arr[i].slice(1);
        fixCharCount++;
      }
    }
  });
  return textArray;
}

// 名前を半角空白まで or 10文字までに変換する
// 10文字目に半角／全角空白が来た場合のみ9文字となる
function nameAdjuster(name) {
  // 半角空白が何文字目にあるか確認
  var index = name.indexOf(" ");
  // 1~10文字目であれば半角空白の前までを返す
  if (0 <= index && index < 10) {
    return name.substr(0, index) + "…";
  }

  // 以下は10文字以内に半角空白が無かった場合

  // 文字数が10文字以下の場合、そのまま返す
  if (name.length <= 10) {
    return name;
  }

  // 文字数が10文字以上の場合、全角空白を考慮しつつ、10文字に変換して返す
  if (name.indexOf("　") === 9) {
    return name.substr(0, 9) + "…";
  } else {
    return name.substr(0, 10) + "…";
  }
}
